
                import "css-modules://src_body"
                export default {"Body":"_836ebc","Rose":"_0f2f05","Grey":"_752eb1","IsFixed":"_4691f2"}
            